import { useContext, useEffect } from 'react'

import useRerender from '@aytm/lib/hooks/useRerender'

import { ISessionAPI } from './types'

import SessionAPIContext from './Session/SessionAPI.Context'

export default function useSession() {
  const sessionAPI = useContext<ISessionAPI>(SessionAPIContext)
  return sessionAPI
}

export function useReactiveSession() {
  const sessionAPI = useContext<ISessionAPI>(SessionAPIContext)
  const rerender = useRerender()

  useEffect(() => {
    const unsubscribe = sessionAPI?.onUpdate(rerender)
    return () => unsubscribe?.()
  }, [sessionAPI, rerender])

  return sessionAPI
}
